import React from 'react';
import BaseModal from '@src/components/modal';
import WcpDownload from './wcp-download';

const DownloadModal = {
  self: null,
  show(data = {}) {
    // 20250208 改为跳首页
    this.self = BaseModal.show({
      wrapClassName: 'nw-base-modal nw-base-modal-p-0 wcp-download-modal',
      borderRadius: 24,
      // closable: false,
      content: (
        <WcpDownload
          {...data}
          onClose={() => {
            this.close();
          }}
        ></WcpDownload>
      ),
      afterClose: () => {
        this.close();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
    }
  },
};

export default DownloadModal;
